import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import { Doughnut } from 'react-chartjs-2';

const PortugalMorocco = {
    labels: [
        'Morocco',
        'Draw',
        'Portugal',
    ],
    datasets: [{
        data: [6300, 2600, 13400],
        backgroundColor: [
            '#FF0000',
            '#FFFFFF',
            '#2e693f',
        ],
        hoverBackgroundColor: [
            '#FF0000',
            '#FFFFFF',
            '#2e693f',
        ],
        borderColor: [
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
        ],
    }]
};
const AustraliaPeru = {
    labels: [
        'Peru',
        'Draw',
        'Australia',
    ],
    datasets: [{
        data: [6100, 4300, 10500],
        backgroundColor: [
            '#db402b',
            '#FFFFFF',
            '#013398',
        ],
        hoverBackgroundColor: [
            '#db402b',
            '#FFFFFF',
            '#013398',
        ],
        borderColor: [
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
        ],
    }]
};
const DenmarkFrance = {
    labels: [
        'Denmark',
        'Draw',
        'France',
    ],
    datasets: [{
        data: [4500, 2700, 7400],
        backgroundColor: [
            '#ed4636',
            '#FFFFFF',
            '#013398',
        ],
        hoverBackgroundColor: [
            '#ed4636',
            '#FFFFFF',
            '#0755a4',
        ],
        borderColor: [
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
        ],
    }]
};
const NigeriaArgentina = {
    labels: [
        'Nigeria',
        'Draw',
        'Argentina',
    ],
    datasets: [{
        data: [6700, 3400, 11200],
        backgroundColor: [
            '#3d8851',
            '#FFFFFF',
            '#75aadb',
        ],
        hoverBackgroundColor: [
            '#3d8851',
            '#FFFFFF',
            '#75aadb',
        ],
        borderColor: [
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
        ],
    }]
};
const IcelandCroatia = {
    labels: [
        'Iceland',
        'Draw',
        'Croatia',
    ],
    datasets: [{
        data: [5700, 2600, 4500],
        backgroundColor: [
            '#00338e',
            '#FFFFFF',
            '#df412c',
        ],
        hoverBackgroundColor: [
            '#00338e',
            '#FFFFFF',
            '#df412c',
        ],
        borderColor: [
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
        ],
    }]
};
const KoreaGermany = {
    labels: [
        'Korea',
        'Draw',
        'Germany',
    ],
    datasets: [{
        data: [6200, 3100, 7800],
        backgroundColor: [
            '#ffffff',
            '#FFFFFF',
            '#fbcc33',
        ],
        hoverBackgroundColor: [
            '#ffffff',
            '#FFFFFF',
            '#fbcc33',
        ],
        borderColor: [
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
        ],
    }]
};
const MexicoSweden = {
    labels: [
        'Mexico',
        'Draw',
        'Sweden',
    ],
    datasets: [{
        data: [7400, 2500, 8900],
        backgroundColor: [
            '#2d6947',
            '#FFFFFF',
            '#0e5293',
        ],
        hoverBackgroundColor: [
            '#2d6947',
            '#FFFFFF',
            '#0e5293',
        ],
        borderColor: [
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
        ],
    }]
};
const BrazilSerbia = {
    labels: [
        'Brazil',
        'Draw',
        'Serbia',
    ],
    datasets: [{
        data: [9100, 2700, 6500],
        backgroundColor: [
            '#449240',
            '#FFFFFF',
            '#dd412b',
        ],
        hoverBackgroundColor: [
            '#449240',
            '#FFFFFF',
            '#dd412b',
        ],
        borderColor: [
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
            'rgba(255, 255, 255, 0)',
        ],
    }]
};
class EventCards extends Component {

    constructor(props) {
        super(props);

        this.state = {

            gridListStatus: 'grid',
        };
        this.handleGridListClick = this.handleGridListClick.bind(this);

    }
    handleGridListClick() {
        if (this.state.gridListStatus === "list") {
            this.setState({ gridListStatus: "grid" })
        }
        if (this.state.gridListStatus === "grid") {
            this.setState({ gridListStatus: "list" })
        }
    }
    render() {


        let GridList = "";
        if (this.state.gridListStatus === "grid") {
            GridList =
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12 select-sport-grid-wrap">
                    <div onClick={this.handleGridListClick} className="list-grid-option animated slideInDown"><Icon className="animated rotateIn" name="list" /> View list</div>
                    <div className="row">
                        <div onClick={this.handleSingleEventsClick} className="col-lg-6 col-md-12 col-sm-12">
                            <div className="main-page-cards-live">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: 'rgb(255,0,0)', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(46,105,63)', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="mybets-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>22.3k Bets</span>
                                    </div>
                                </div>
                                <div className="row mybets-page-rows-teams">
                                    <div className="col-5 mybets-page-rows-teams-teamone">
                                        <span><img src="http://www.countryflags.io/PT/flat/64.png" width="30px" /></span>
                                        <div>Portugal</div>
                                    </div>

                                    <div className="col-2 mybets-page-rows-teams-vs">
                                        <div style={{ marginTop: '-10px' }}>
                                            <Doughnut
                                                legend={null}
                                                width={110}
                                                options={{
                                                    maintainAspectRatio: false
                                                }}
                                                height={55}
                                                data={PortugalMorocco}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 mybets-page-rows-teams-teamtwo">
                                        <span><img src="http://www.countryflags.io/MA/flat/64.png" width="30px" /></span>
                                        <div>Morocco</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-event-info">
                                    <div className="col">
                                        <div>FIFA WORLD CUP - Group B, Luzhniki Stadium Moscow</div>
                                        <div>20 Jun 2018 - 15:00 GMT-4</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-bet-options">
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                        <span className="main-page-cards-bet-options-title">PORTUGAL</span>
                                        <div className="main-page-cards-bet-bet-amount">13.4K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                        <span className="main-page-cards-bet-options-title">DRAW</span>
                                        <div className="main-page-cards-bet-bet-amount">2.6K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                        <span className="main-page-cards-bet-options-title">MOROCCO</span>
                                        <div className="main-page-cards-bet-bet-amount">6.3K BETS</div>
                                    </button>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '15px 0px 0px 0px', color: '#c6153e', textAlign: 'left' }}>
                                        <div className="live-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px', fontWeight: 'bolder' }}>Live</span> <span style={{ padding: '13px 0px 0px 5px', color: '#758c94', fontSize: '12px' }}>1ST HALF</span></div>

                                    <div className="col-4 watch-live-col">

                                        <div className="watch-live">
                                            <Icon width="14" name="play" />
                                            WATCH LIVE
            </div>
                                    </div>
                                    <div className="col-4 watching-amount">
                                        <Icon style={{ marginRight: '7px', marginBottom: '2px' }} width="14" name="eye" />
                                        21.1K
</div>
                                </div>

                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="main-page-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#db402b', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#013398', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="mybets-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>20.9k Bets</span>
                                    </div>
                                </div>
                                <div className="row mybets-page-rows-teams">

                                    <div className="col-5 mybets-page-rows-teams-teamone">
                                        <span><img src="http://www.countryflags.io/AU/flat/64.png" width="30px" /></span>
                                        <div>Australia</div>
                                    </div>
                                    <div className="col-2 mybets-page-rows-teams-vs">
                                        <div style={{ marginTop: '-10px' }}>
                                            <Doughnut
                                                legend={null}
                                                width={110}
                                                options={{
                                                    maintainAspectRatio: false
                                                }}
                                                height={55}
                                                data={AustraliaPeru}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 mybets-page-rows-teams-teamtwo">
                                        <span><img src="http://www.countryflags.io/PE/flat/64.png" width="30px" /></span>
                                        <div>Peru</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-event-info">
                                    <div className="col">
                                        <div>FIFA WORLD CUP - Group C, Fisht Stadium Sochi</div>
                                        <div>26 Jun 2018 - 17:00 Local time</div>
                                    </div>
                                </div>


                                <div className="row main-page-cards-bet-options">
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                        <span className="main-page-cards-bet-options-title">AUSTRALIA</span>
                                        <div className="main-page-cards-bet-bet-amount">6.1K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                        <span className="main-page-cards-bet-options-title">DRAW</span>
                                        <div className="main-page-cards-bet-bet-amount">4.3K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                        <span className="main-page-cards-bet-options-title">PERU</span>
                                        <div className="main-page-cards-bet-bet-amount">10.5K BETS</div>
                                    </button>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>Open</span></div>

                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="main-page-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#ed4636', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#013398', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="mybets-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>14.6k Bets</span>
                                    </div>
                                </div>
                                <div className="row mybets-page-rows-teams">
                                    <div className="col-5 mybets-page-rows-teams-teamone">
                                        <span><img src="http://www.countryflags.io/DK/flat/64.png" width="30px" /></span>
                                        <div>Denmark</div>
                                    </div>
                                    <div className="col-2 mybets-page-rows-teams-vs">
                                        <div style={{ marginTop: '-10px' }}>
                                            <Doughnut
                                                legend={null}
                                                width={110}
                                                options={{
                                                    maintainAspectRatio: false
                                                }}
                                                height={55}
                                                data={DenmarkFrance}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 mybets-page-rows-teams-teamtwo">
                                        <span><img src="http://www.countryflags.io/FR/flat/64.png" width="30px" /></span>
                                        <div>France</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-event-info">
                                    <div className="col">
                                        <div>FIFA WORLD CUP - Group C, Luzhniki Stadium Moscow</div>
                                        <div>26 Jun 2018 - 17:00 Local time</div>
                                    </div>
                                </div>

                                <div className="row main-page-cards-bet-options">
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                        <span className="main-page-cards-bet-options-title">DENMARK</span>
                                        <div className="main-page-cards-bet-bet-amount">4.5K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                        <span className="main-page-cards-bet-options-title">DRAW</span>
                                        <div className="main-page-cards-bet-bet-amount">2.7K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                        <span className="main-page-cards-bet-options-title">FRANCE</span>
                                        <div className="main-page-cards-bet-bet-amount">7.4K BETS</div>
                                    </button>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>Open</span></div>

                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="main-page-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#3d8851', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#75aadb', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="mybets-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>21.3k Bets</span>
                                    </div>
                                </div>
                                <div className="row mybets-page-rows-teams">
                                    <div className="col-5 mybets-page-rows-teams-teamone">
                                        <span><img src="http://www.countryflags.io/NG/flat/64.png" width="30px" /></span>
                                        <div>Nigeria</div>
                                    </div>
                                    <div className="col-2 mybets-page-rows-teams-vs">
                                        <div style={{ marginTop: '-10px' }}>
                                            <Doughnut
                                                legend={null}
                                                width={110}
                                                options={{
                                                    maintainAspectRatio: false
                                                }}
                                                height={55}
                                                data={NigeriaArgentina}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 mybets-page-rows-teams-teamtwo">
                                        <span><img src="http://www.countryflags.io/AR/flat/64.png" width="30px" /></span>
                                        <div>Argentina</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-event-info">
                                    <div className="col">
                                        <div>FIFA WORLD CUP - Group D, St. Petersburg Stadium</div>
                                        <div>26 Jun 2018 - 21:00 Local time</div>
                                    </div>
                                </div>

                                <div className="row main-page-cards-bet-options">
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                        <span className="main-page-cards-bet-options-title">Nigeria</span>
                                        <div className="main-page-cards-bet-bet-amount">6.7K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                        <span className="main-page-cards-bet-options-title">DRAW</span>
                                        <div className="main-page-cards-bet-bet-amount">3.4K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                        <span className="main-page-cards-bet-options-title">Argentina</span>
                                        <div className="main-page-cards-bet-bet-amount">11.2K BETS</div>
                                    </button>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>

                                </div>
                            </div>
                        </div>



                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="main-page-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#00338e', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#df412c', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="mybets-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>12.8k Bets</span>
                                    </div>
                                </div>
                                <div className="row mybets-page-rows-teams">
                                    <div className="col-5 mybets-page-rows-teams-teamone">
                                        <span><img src="http://www.countryflags.io/IS/flat/64.png" width="30px" /></span>
                                        <div>Iceland</div>
                                    </div>
                                    <div className="col-2 mybets-page-rows-teams-vs">
                                        <div style={{ marginTop: '-10px' }}>
                                            <Doughnut
                                                legend={null}
                                                width={110}
                                                options={{
                                                    maintainAspectRatio: false
                                                }}
                                                height={55}
                                                data={IcelandCroatia}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 mybets-page-rows-teams-teamtwo">
                                        <span><img src="http://www.countryflags.io/HR/flat/64.png" width="30px" /></span>
                                        <div>Croatia</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-event-info">
                                    <div className="col">
                                        <div>FIFA WORLD CUP - Group D, Rostov Arena Rostov-On-Don</div>
                                        <div>26 Jun 2018 - 21:00 Local time</div>
                                    </div>
                                </div>

                                <div className="row main-page-cards-bet-options">
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                        <span className="main-page-cards-bet-options-title">Iceland</span>
                                        <div className="main-page-cards-bet-bet-amount">5.7K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                        <span className="main-page-cards-bet-options-title">DRAW</span>
                                        <div className="main-page-cards-bet-bet-amount">2.6K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                        <span className="main-page-cards-bet-options-title">Croatia</span>
                                        <div className="main-page-cards-bet-bet-amount">4.5K BETS</div>
                                    </button>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>

                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="main-page-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(46,105,63)', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#fbcc33', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="mybets-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>17.1k Bets</span>
                                    </div>
                                </div>
                                <div className="row mybets-page-rows-teams">
                                    <div className="col-5 mybets-page-rows-teams-teamone">
                                        <span><img src="http://www.countryflags.io/KR/flat/64.png" width="30px" /></span>
                                        <div>Korea Republic</div>
                                    </div>
                                    <div className="col-2 mybets-page-rows-teams-vs">
                                        <div style={{ marginTop: '-10px' }}>
                                            <Doughnut
                                                legend={null}
                                                width={110}
                                                options={{
                                                    maintainAspectRatio: false
                                                }}
                                                height={55}
                                                data={KoreaGermany}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 mybets-page-rows-teams-teamtwo">
                                        <span><img src="http://www.countryflags.io/DE/flat/64.png" width="30px" /></span>
                                        <div>Germany</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-event-info">
                                    <div className="col">
                                        <div>FIFA WORLD CUP - Group F, Kazan Arena Kazan</div>
                                        <div>27 Jun 2018 - 17:00 Local time</div>
                                    </div>
                                </div>

                                <div className="row main-page-cards-bet-options">
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                        <span className="main-page-cards-bet-options-title">Korea Republic</span>
                                        <div className="main-page-cards-bet-bet-amount">6.2K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                        <span className="main-page-cards-bet-options-title">DRAW</span>
                                        <div className="main-page-cards-bet-bet-amount">3.1K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                        <span className="main-page-cards-bet-options-title">Germany</span>
                                        <div className="main-page-cards-bet-bet-amount">7.8K BETS</div>
                                    </button>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>

                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="main-page-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#2d6947', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#0e5293', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="mybets-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>18.8k Bets</span>
                                    </div>
                                </div>
                                <div className="row mybets-page-rows-teams">
                                    <div className="col-5 mybets-page-rows-teams-teamone">
                                        <span><img src="http://www.countryflags.io/MX/flat/64.png" width="30px" /></span>
                                        <div>Mexico</div>
                                    </div>
                                    <div className="col-2 mybets-page-rows-teams-vs">
                                        <div style={{ marginTop: '-10px' }}>
                                            <Doughnut
                                                legend={null}
                                                width={110}
                                                options={{
                                                    maintainAspectRatio: false
                                                }}
                                                height={55}
                                                data={MexicoSweden}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 mybets-page-rows-teams-teamtwo">
                                        <span><img src="http://www.countryflags.io/SE/flat/64.png" width="30px" /></span>
                                        <div>Sweden</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-event-info">
                                    <div className="col">
                                        <div>FIFA WORLD CUP - Group F, Ekaterinburg Arena Ekaterinburg</div>
                                        <div>27 Jun 2018 - 19:00 Local time</div>
                                    </div>
                                </div>

                                <div className="row main-page-cards-bet-options">
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                        <span className="main-page-cards-bet-options-title">Mexico</span>
                                        <div className="main-page-cards-bet-bet-amount">7.4K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                        <span className="main-page-cards-bet-options-title">DRAW</span>
                                        <div className="main-page-cards-bet-bet-amount">2.5K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                        <span className="main-page-cards-bet-options-title">Sweden</span>
                                        <div className="main-page-cards-bet-bet-amount">8.9K BETS</div>
                                    </button>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>

                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="main-page-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#449240', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#dd412b', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="mybets-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>18.3k Bets</span>
                                    </div>
                                </div>
                                <div className="row mybets-page-rows-teams">
                                    <div className="col-5 mybets-page-rows-teams-teamone">
                                        <span><img src="http://www.countryflags.io/BR/flat/64.png" width="30px" /></span>
                                        <div>Brazil</div>
                                    </div>
                                    <div className="col-2 mybets-page-rows-teams-vs">
                                        <div style={{ marginTop: '-10px' }}>
                                            <Doughnut
                                                legend={null}
                                                width={110}
                                                options={{
                                                    maintainAspectRatio: false
                                                }}
                                                height={55}
                                                data={BrazilSerbia}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 mybets-page-rows-teams-teamtwo">
                                        <span><img src="http://www.countryflags.io/RS/flat/64.png" width="30px" /></span>
                                        <div>Serbia</div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-event-info">
                                    <div className="col">
                                        <div>FIFA WORLD CUP - Group E, Spartak Stadium Moscow</div>
                                        <div>27 Jun 2018 - 21:00 Local time</div>
                                    </div>
                                </div>

                                <div className="row main-page-cards-bet-options">
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                        <span className="main-page-cards-bet-options-title">Brazil</span>
                                        <div className="main-page-cards-bet-bet-amount">9.1K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                        <span className="main-page-cards-bet-options-title">DRAW</span>
                                        <div className="main-page-cards-bet-bet-amount">2.7K BETS</div>
                                    </button>
                                    <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                        <span className="main-page-cards-bet-options-title">Serbia</span>
                                        <div className="main-page-cards-bet-bet-amount">6.5K BETS</div>
                                    </button>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        }
        if (this.state.gridListStatus === "list") {
            GridList =
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12 select-sport-grid-wrap">
                    <div onClick={this.handleGridListClick} className="list-grid-option animated slideInDown">
                        <Icon name="grid layout" /> View Grid
                    </div>
                    <div className="cards-list-container">
                        <div onClick={this.handleSingleEventsClick} className="row cards-list">
                            <div className="main-page-list-cards-live">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: 'rgb(255,0,0)', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(46,105,63)', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="list-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>22.3k Bets</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row list-page-rows-teams">
                                            <div className="col-5 mybets-page-rows-teams-teamone">
                                                <span><img src="http://www.countryflags.io/PT/flat/64.png" width="30px" /></span>
                                                <div>Portugal</div>
                                            </div>
                                            <div className="col-2 mybets-page-rows-teams-vs">
                                                <div style={{ marginTop: '-10px' }}>
                                                    <Doughnut
                                                        legend={null}
                                                        width={110}
                                                        options={{
                                                            maintainAspectRatio: false
                                                        }}
                                                        height={55}
                                                        data={PortugalMorocco}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5 mybets-page-rows-teams-teamtwo">
                                                <span><img src="http://www.countryflags.io/MA/flat/64.png" width="30px" /></span>
                                                <div>Morocco</div>
                                            </div>
                                        </div>
                                        <div className="row main-page-cards-event-info">
                                            <div className="col">
                                                <div>FIFA WORLD CUP - Group B, Luzhniki Stadium Moscow</div>
                                                <div>20 Jun 2018 - 15:00 GMT-4</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row list-page-cards-bet-options">
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                                <span className="main-page-cards-bet-options-title">PORTUGAL</span>
                                                <div className="main-page-cards-bet-bet-amount">13.4K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                                <span className="main-page-cards-bet-options-title">DRAW</span>
                                                <div className="main-page-cards-bet-bet-amount">2.6K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                                <span className="main-page-cards-bet-options-title">MOROCCO</span>
                                                <div className="main-page-cards-bet-bet-amount">6.3K BETS</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '15px 0px 0px 0px', color: '#c6153e', textAlign: 'left' }}>
                                        <div className="live-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px', fontWeight: 'bolder' }}>Live</span> <span style={{ padding: '13px 0px 0px 5px', color: '#758c94', fontSize: '12px' }}>1ST HALF</span></div>
                                    <div className="col-4 watch-live-col">

                                        <div className="watch-live">
                                            <Icon width="14" name="play" />
                                            WATCH LIVE
                                        </div>
                                    </div>
                                    <div className="col-4 watching-amount">
                                        <Icon style={{ marginRight: '7px', marginBottom: '2px' }} width="14" name="eye" />
                                        21.1K
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row cards-list">
                            <div className="main-page-list-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#db402b', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#013398', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="list-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>20.9k Bets</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row list-page-rows-teams">
                                            <div className="col-5 mybets-page-rows-teams-teamone">
                                                <span><img src="http://www.countryflags.io/AU/flat/64.png" width="30px" /></span>
                                                <div>Australia</div>
                                            </div>
                                            <div className="col-2 mybets-page-rows-teams-vs">
                                                <div style={{ marginTop: '-10px' }}>
                                                    <Doughnut
                                                        legend={null}
                                                        width={110}
                                                        options={{
                                                            maintainAspectRatio: false
                                                        }}
                                                        height={55}
                                                        data={AustraliaPeru}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5 mybets-page-rows-teams-teamtwo">
                                                <span><img src="http://www.countryflags.io/PE/flat/64.png" width="30px" /></span>
                                                <div>Peru</div>
                                            </div>
                                        </div>
                                        <div className="row main-page-cards-event-info">
                                            <div className="col">
                                                <div>FIFA WORLD CUP - Group C, Fisht Stadium Sochi</div>
                                                <div>26 Jun 2018 - 17:00 Local time</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row list-page-cards-bet-options">
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                                <span className="main-page-cards-bet-options-title">AUSTRALIA</span>
                                                <div className="main-page-cards-bet-bet-amount">6.1K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                                <span className="main-page-cards-bet-options-title">DRAW</span>
                                                <div className="main-page-cards-bet-bet-amount">4.3K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                                <span className="main-page-cards-bet-options-title">PERU</span>
                                                <div className="main-page-cards-bet-bet-amount">10.5K BETS</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>Open</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="row cards-list">
                            <div className="main-page-list-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#ed4636', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#013398', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="list-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>14.6k Bets</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row list-page-rows-teams">
                                            <div className="col-5 mybets-page-rows-teams-teamone">
                                                <span><img src="http://www.countryflags.io/DK/flat/64.png" width="30px" /></span>
                                                <div>Denmark</div>
                                            </div>
                                            <div className="col-2 mybets-page-rows-teams-vs">
                                                <div style={{ marginTop: '-10px' }}>
                                                    <Doughnut
                                                        legend={null}
                                                        width={110}
                                                        options={{
                                                            maintainAspectRatio: false
                                                        }}
                                                        height={55}
                                                        data={DenmarkFrance}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5 mybets-page-rows-teams-teamtwo">
                                                <span><img src="http://www.countryflags.io/FR/flat/64.png" width="30px" /></span>
                                                <div>France</div>
                                            </div>
                                        </div>
                                        <div className="row main-page-cards-event-info">
                                            <div className="col">
                                                <div>FIFA WORLD CUP - Group C, Luzhniki Stadium Moscow</div>
                                                <div>26 Jun 2018 - 17:00 Local time</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row list-page-cards-bet-options">
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                                <span className="main-page-cards-bet-options-title">DENMARK</span>
                                                <div className="main-page-cards-bet-bet-amount">4.5K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                                <span className="main-page-cards-bet-options-title">DRAW</span>
                                                <div className="main-page-cards-bet-bet-amount">2.7K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                                <span className="main-page-cards-bet-options-title">FRANCE</span>
                                                <div className="main-page-cards-bet-bet-amount">7.4K BETS</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>Open</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="row cards-list">
                            <div className="main-page-list-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#3d8851', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#75aadb', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="list-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>21.3k Bets</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row list-page-rows-teams">
                                            <div className="col-5 mybets-page-rows-teams-teamone">
                                                <span><img src="http://www.countryflags.io/NG/flat/64.png" width="30px" /></span>
                                                <div>Nigeria</div>
                                            </div>
                                            <div className="col-2 mybets-page-rows-teams-vs">
                                                <div style={{ marginTop: '-10px' }}>
                                                    <Doughnut
                                                        legend={null}
                                                        width={110}
                                                        options={{
                                                            maintainAspectRatio: false
                                                        }}
                                                        height={55}
                                                        data={NigeriaArgentina}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5 mybets-page-rows-teams-teamtwo">
                                                <span><img src="http://www.countryflags.io/AR/flat/64.png" width="30px" /></span>
                                                <div>Argentina</div>
                                            </div>
                                        </div>
                                        <div className="row main-page-cards-event-info">
                                            <div className="col">
                                                <div>FIFA WORLD CUP - Group D, St. Petersburg Stadium</div>
                                                <div>26 Jun 2018 - 21:00 Local time</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row list-page-cards-bet-options">
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                                <span className="main-page-cards-bet-options-title">Nigeria</span>
                                                <div className="main-page-cards-bet-bet-amount">6.7K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                                <span className="main-page-cards-bet-options-title">DRAW</span>
                                                <div className="main-page-cards-bet-bet-amount">3.4K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                                <span className="main-page-cards-bet-options-title">Argentina</span>
                                                <div className="main-page-cards-bet-bet-amount">11.2K BETS</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="row cards-list">
                            <div className="main-page-list-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#00338e', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#df412c', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="list-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>12.8k Bets</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row list-page-rows-teams">
                                            <div className="col-5 mybets-page-rows-teams-teamone">
                                                <span><img src="http://www.countryflags.io/IS/flat/64.png" width="30px" /></span>
                                                <div>Iceland</div>
                                            </div>
                                            <div className="col-2 mybets-page-rows-teams-vs">
                                                <div style={{ marginTop: '-10px' }}>
                                                    <Doughnut
                                                        legend={null}
                                                        width={110}
                                                        options={{
                                                            maintainAspectRatio: false
                                                        }}
                                                        height={55}
                                                        data={IcelandCroatia}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5 mybets-page-rows-teams-teamtwo">
                                                <span><img src="http://www.countryflags.io/HR/flat/64.png" width="30px" /></span>
                                                <div>Croatia</div>
                                            </div>
                                        </div>
                                        <div className="row main-page-cards-event-info">
                                            <div className="col">
                                                <div>FIFA WORLD CUP - Group D, Rostov Arena Rostov-On-Don</div>
                                                <div>26 Jun 2018 - 21:00 Local time</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row list-page-cards-bet-options">
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                                <span className="main-page-cards-bet-options-title">Iceland</span>
                                                <div className="main-page-cards-bet-bet-amount">5.7K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                                <span className="main-page-cards-bet-options-title">DRAW</span>
                                                <div className="main-page-cards-bet-bet-amount">2.6K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                                <span className="main-page-cards-bet-options-title">Croatia</span>
                                                <div className="main-page-cards-bet-bet-amount">4.5K BETS</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>

                                </div>
                            </div>
                        </div>
                        <div className="row cards-list">
                            <div className="main-page-list-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(46,105,63)', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#fbcc33', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="list-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>17.1k Bets</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row list-page-rows-teams">
                                            <div className="col-5 mybets-page-rows-teams-teamone">
                                                <span><img src="http://www.countryflags.io/KR/flat/64.png" width="30px" /></span>
                                                <div>Korea Republic</div>
                                            </div>
                                            <div className="col-2 mybets-page-rows-teams-vs">
                                                <div style={{ marginTop: '-10px' }}>
                                                    <Doughnut
                                                        legend={null}
                                                        width={110}
                                                        options={{
                                                            maintainAspectRatio: false
                                                        }}
                                                        height={55}
                                                        data={KoreaGermany}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5 mybets-page-rows-teams-teamtwo">
                                                <span><img src="http://www.countryflags.io/DE/flat/64.png" width="30px" /></span>
                                                <div>Germany</div>
                                            </div>
                                        </div>
                                        <div className="row main-page-cards-event-info">
                                            <div className="col">
                                                <div>FIFA WORLD CUP - Group F, Kazan Arena Kazan</div>
                                                <div>27 Jun 2018 - 17:00 Local time</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row list-page-cards-bet-options">
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                                <span className="main-page-cards-bet-options-title">Korea Republic</span>
                                                <div className="main-page-cards-bet-bet-amount">6.2K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                                <span className="main-page-cards-bet-options-title">DRAW</span>
                                                <div className="main-page-cards-bet-bet-amount">3.1K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                                <span className="main-page-cards-bet-options-title">Germany</span>
                                                <div className="main-page-cards-bet-bet-amount">7.8K BETS</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>

                                </div>
                            </div>
                        </div>
                        <div className="row cards-list">
                            <div className="main-page-list-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#2d6947', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#0e5293', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="list-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>18.8k Bets</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row list-page-rows-teams">
                                            <div className="col-5 mybets-page-rows-teams-teamone">
                                                <span><img src="http://www.countryflags.io/MX/flat/64.png" width="30px" /></span>
                                                <div>Mexico</div>
                                            </div>
                                            <div className="col-2 mybets-page-rows-teams-vs">
                                                <div style={{ marginTop: '-10px' }}>
                                                    <Doughnut
                                                        legend={null}
                                                        width={110}
                                                        options={{
                                                            maintainAspectRatio: false
                                                        }}
                                                        height={55}
                                                        data={MexicoSweden}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5 mybets-page-rows-teams-teamtwo">
                                                <span><img src="http://www.countryflags.io/SE/flat/64.png" width="30px" /></span>
                                                <div>Sweden</div>
                                            </div>
                                        </div>
                                        <div className="row main-page-cards-event-info">
                                            <div className="col">
                                                <div>FIFA WORLD CUP - Group F, Ekaterinburg Arena Ekaterinburg</div>
                                                <div>27 Jun 2018 - 19:00 Local time</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row list-page-cards-bet-options">
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                                <span className="main-page-cards-bet-options-title">Mexico</span>
                                                <div className="main-page-cards-bet-bet-amount">7.4K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                                <span className="main-page-cards-bet-options-title">DRAW</span>
                                                <div className="main-page-cards-bet-bet-amount">2.5K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                                <span className="main-page-cards-bet-options-title">Sweden</span>
                                                <div className="main-page-cards-bet-bet-amount">8.9K BETS</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>

                                </div>
                            </div>
                        </div>
                        <div className="row cards-list">
                            <div className="main-page-list-cards-open">
                                <div className="graph-lines-wrapper">
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width='40%'>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: '#449240', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width='25%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: '#dd412b', strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="thirdLine" height={10} width='35%'>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: 'rgb(255,255,255)', strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                </div>
                                <div className="list-page-rows-teams-betcount-wrap">
                                    <div className="mybets-page-rows-teams-betcount">
                                        <span>18.3k Bets</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row list-page-rows-teams">
                                            <div className="col-5 mybets-page-rows-teams-teamone">
                                                <span><img src="http://www.countryflags.io/BR/flat/64.png" width="30px" /></span>
                                                <div>Brazil</div>
                                            </div>
                                            <div className="col-2 mybets-page-rows-teams-vs">
                                                <div style={{ marginTop: '-10px' }}>
                                                    <Doughnut
                                                        legend={null}
                                                        width={110}
                                                        options={{
                                                            maintainAspectRatio: false
                                                        }}
                                                        height={55}
                                                        data={BrazilSerbia}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5 mybets-page-rows-teams-teamtwo">
                                                <span><img src="http://www.countryflags.io/RS/flat/64.png" width="30px" /></span>
                                                <div>Serbia</div>
                                            </div>
                                        </div>
                                        <div className="row main-page-cards-event-info">
                                            <div className="col">
                                                <div>FIFA WORLD CUP - Group E, Spartak Stadium Moscow</div>
                                                <div>27 Jun 2018 - 21:00 Local time</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row list-page-cards-bet-options">
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamone">
                                                <span className="main-page-cards-bet-options-title">Brazil</span>
                                                <div className="main-page-cards-bet-bet-amount">9.1K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-draw">
                                                <span className="main-page-cards-bet-options-title">DRAW</span>
                                                <div className="main-page-cards-bet-bet-amount">2.7K BETS</div>
                                            </button>
                                            <button data-toggle="modal" data-target="#icelandModal" className="col main-page-cards-options-teamtwo">
                                                <span className="main-page-cards-bet-options-title">Serbia</span>
                                                <div className="main-page-cards-bet-bet-amount">6.5K BETS</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row main-page-cards-status">
                                    <div className="col-4" style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left' }}>
                                        <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>open</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        }
        return (
            <div className="select-match-wrap">
                <div className="select-match">
                    <div className="heading-wrap animated bounce">
                        <div className="main-heading-title">
                            <span className="heading-number">2</span>
                            Select a Match
                    </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 select-sport-info">
                            <div className="sub-item-wrapper">
                                {/* <div className="subheading"><span className="subheading-number">2.1</span>HEADING</div> */}
                                <div className="info-description">
After selecting a sport and possibly league, you will be presented with the available matches to bet on. Every match here is represented
in the smart-contract platform.<br /><br /> This page provides all
the key information on matches at a quick glance. You can bet on a match from this page or selecting a match will take you to a more detailed betting page.<br /><br />
When the Mevu platform launches only the Mevu team will be creating matches to bet on but we will transition to a system where
verified oracles create events they believe will be popular and then are rewarded if they turn out to be.</div>
                            </div>
                            {/* <div className="sub-item-wrapper">
                                <div className="subheading"><span className="subheading-number">2.2</span>HEADING</div>
                                <div className="info-description">Lorem ipsum dolor sit amet, consectetuer adipisc
                                ing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
                            Ut wisi enim ad minim veniam, quis nostrud exerci tation. </div>
                            </div> */}
                        </div>
                        {GridList}
                    </div>
                </div>
            </div>

        );
    }
}

export default EventCards;



// WEBPACK FOOTER //
// ./src/Components/EventCards.js